<template>
  <div class="search-con">
    <div>
      <div class="search-item">
          <left-text-border class="w-30" leftText="订单号" v-model="formData.oid"  @enter="searchSubmit"  placeholder="请输入订单号"/>
          <left-text-border class="w-30 mb-3" leftText="团号" v-model="formData.title_id"  @enter="searchSubmit"  placeholder="请输入团号" v-if="isExpand"/>
          <left-text-border class="w-30" leftText="酒店名称" v-model="formData.hotel_title"  @enter="searchSubmit"  placeholder="请输入酒店名称" v-if="userInfo.type==2"/>
          <left-text-border class="w-30" leftText="旅行社名称" v-model="formData.travel_title"  @enter="searchSubmit"  placeholder="请输入旅行社名称" v-if="userInfo.type==3"/>
          <div class="w-30 d-center-start" v-if="isAdmin">
            <el-select v-model="nameType" placeholder="查询名称" size="small" class="mr-1" style="width: 145px;" @change="changeNameType">
                <el-option v-for="item in isAdminName" :key="item.value" :label="item.name" :value="item.value" />
            </el-select>
            <left-text-border class="w-100"  v-model="formData[nameType]"  @enter="searchSubmit"  placeholder="请输入查询名称"/>
          </div>
          <!--模式1-->
          <div class="w-30 text-expand" v-if="!isExpand">
            <el-button type="primary" size="small" @click="searchSubmit()" icon="el-icon-search">搜索</el-button>
            <el-button  size="small" @click="resetSearch()" icon="el-icon-refresh">重置</el-button>
            <p class="text-cancel ml-2" @click="searchExpand(1)"><i class="el-icon-arrow-down"></i></p> 
          </div>
      </div>
      <div class="search-item" v-if="isExpand">
          <left-text-select class="w-30 mb-3" :leftText="userInfo.type==2?'支付酒店':'收款状态'" :options=" userInfo.type==3?paymentStatusHotel:paymentStatus" v-model="formData.pay_flag"  @input="searchSubmit" v-if="!confSlip&&!isAdmin" />
          <left-text-select class="w-30 mb-3" leftText="付款状态" :options=" isAdminPaymentStatus" v-model="formData.pay_flag"  @input="searchSubmit" v-else />
          <left-text-select class="w-30 mb-3 " leftText="订单收款" :options="paymentMode " v-model="formData.broker"  @input="searchSubmit" v-show="userInfo.type!=3&&!confSlip"/>
          <div class="w-30 mb-3 d-center-start " :class="{'lidqs':userInfo.type==3}">
              <el-select v-model="timeType" placeholder="时间查询" size="small" class="mr-1" style="width: 145px;">
                  <el-option v-for="item in timeChoose" :key="item.value" :label="item.name" :value="item.value" />
              </el-select>
              <el-date-picker v-model="timestamp" type="daterange" class="w-100" size="small"
                      v-show="$GFUN.isInArray(['timeFrame','postTime','dealTime'],timeType)"
                      range-separator="至" value-format="timestamp" start-placeholder="开始时间"
                      end-placeholder="结束时间" />
              <el-date-picker type="dates" v-model="timetime" class="w-100" size="small" v-show="timeType === 'timeArr'" placeholder="可选择一个或多个日期" />
          </div>
          <left-text-select class="w-30 mb-3" leftText="旗下人员" :options="user_list" v-model="formData.uid"  @input="searchSubmit" v-if="!isAdmin&&userInfo.type==3&&isGroup" />
      </div>
      <div class="bottom" v-if="isExpand">
        <left-text-select class="w-30 lies" leftText="旗下人员" :options="user_list" v-model="formData.uid"  @input="searchSubmit" v-if="!isAdmin&&userInfo.type==2&&isGroup" />
        <el-button type="primary" size="small" @click="searchSubmit()" icon="el-icon-search">搜索</el-button>
        <el-button  size="small" @click="resetSearch()" icon="el-icon-refresh">重置</el-button>
        <p class="text-cancel ml-2" @click="searchExpand(2)"><i class="el-icon-arrow-up"></i></p>
      </div>
    </div>
    <!-- <div class="text-expand">
      展开搜索
      <p class="text-cancel"></p>
    </div> -->
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { debounce } from "lodash";
export default {
  name: '',
  components: {},
  props: {
    //是否是确认单标识
    confSlip:{
        type:Boolean,
        default:false
    },
    //旗下人员
    user_list:{
        type:Array,
        default:()=>[]
    }
  },
  data() {
    return {
        //是否搜索了订单
        isSearch:false,
        formData:{
          oid:'',                   //订单号
          title:'',                 //团号
          hotel_title:'',          //酒店名称
          travel_title:'',          //旅行社名称
          pay_flag: '',             //支付酒店/收款状态
          broker:'',                //订单收款
          uid:'',                   //旗下人员
        },
        //搜索展开模式
        isExpand:false,
        paymentStatus:[
          {name: '全部', id: ''}, 
          {name: '未支付', id: '2'},
          {name: '已支付', id: '1'},
        ],
        paymentStatusHotel:[
            {name: '全部', id: ''}, 
            {name: '未收款', id: '2'},
            {name: '已收款', id: '1'},
        ],
        paymentMode:[
            {name: '全部', id: ''}, 
            {name: '代订收款', id: '1'},
        ],
        timeChoose:[
            {name:`入住时间段`,value:'timeFrame'},
            {name:`入住日`,value:'timeArr'},
            {name:`发单时间`,value:'postTime'},
            {name:`成交时间`,value:'dealTime'}
        ],
        isAdminPaymentStatus: [
          {name: '全部', id: ''}, 
          {name: '待收款', id: '1'},
          {name: '已收款', id: '2'},
          {name: '待付款', id: '3'},
          {name: '已付款', id: '4'},
        ],
        isAdminName:[
            {name:`酒店名称`,value:'hotel_title'},
            {name:`旅行社名称`,value:'travel_title'},
        ],
        timeType:'timeFrame',
        nameType:'travel_title',
        timestamp: [],
        timetime:[],
    };
  },
  computed: {
     ...mapGetters(['storeInfo','userInfo','isAdmin','isGroup']),
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
      //查询名称类型改变时，清空查询名称
      changeNameType(){
        this.formData[this.nameType] = '';
      },
      //提交搜索条件
      searchSubmit: debounce(function() {
        let data = {
          ...this.formData,
        }
        let start = this.timestamp && this.timestamp.length > 0 ? this.timestamp[0] / 1000 : '';
        let end = this.timestamp && this.timestamp.length > 0 ? this.timestamp[1] / 1000 + 86399 : '';
        switch (this.timeType) {
          case 'timeArr':
            let timeArr = this.timetime ? this.timetime.map(v => {return ((v.getTime() / 1000) + (this.$GFUN.isInArray([6,7,8],this.orderType) ? 28800 : 0))}) : [];
            data.date_in = timeArr.join(',');
            break;
          case 'timeFrame':
            data.date_in = start;
            data.date_out = end;
            break;
          case 'postTime':data.add_time = start + ',' + end; break;
          case 'dealTime':data.deal_time = start + ',' + end; break;
        }
        //保存是否搜索了订单
        this.isSearch = true;
        this.$emit('getSearchCon',data);
      },300),
      //重置搜索条件
      resetSearch: debounce(function(){
        //重置是否搜索了订单
        this.formData = {
          oid:'',                   //订单号
          title:'',                 //团号
          hotel_title:'',           //酒店名称
          travel_title:'',          //旅行社名称
          pay_flag: '',             //支付酒店/收款状态
          broker:'',                //订单收款
          add_time:'',              //发单时间
          deal_time:'',             //成交时间
          date_in:'',               //入住时间
          date_out:'',              //离店时间
        };
        this.timeType = 'timeFrame';
        this.nameType = 'travel_title';
        this.timestamp = [];
        this.timetime = [];
        //重置搜索条件
        console.log(this.isSearch);
        if(this.isSearch){
          this.$emit('getSearchCon',this.formData);
          this.isSearch = false;
        }
      },300),
      //搜索模式
      searchExpand(res){
        this.isExpand = res == 1 ? true : false;
        this.$emit('isExpand',res)
      },
  }
};
</script>

<style lang="scss" scoped>
 .search-con{
    padding: 15px;
    background-color: #fff;
    border-radius: 6px;
 }
 .search-item{
    display: flex;
    justify-content:space-between;
 }
 .bottom{
   display: flex;
   justify-content: flex-end;
 }
 .lidqs{
  margin-right: auto;
  margin-left: 5.3%;
 }
 .lies{
  margin-right: auto;
 }
 .text-expand{
  display: flex;
  justify-content: flex-end;
  line-height: 30px;
 }
 .text-cancel{
    width: 32px;
    height: 32px;
    background-color: #f5f9fc;
    border:1px solid #e4e7ed;
    border-radius: 4px;
    line-height: 32px;
    color: #333;
    cursor: pointer;
 }
</style>
